import { render } from "./MobileAccountSubpage.vue?vue&type=template&id=e3827704&scoped=true"
import script from "./MobileAccountSubpage.vue?vue&type=script&lang=js"
export * from "./MobileAccountSubpage.vue?vue&type=script&lang=js"

import "./MobileAccountSubpage.vue?vue&type=style&index=0&id=e3827704&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3827704"]])

export default __exports__